// update state
const setCurrentObjectId = (payload) => {
    return {
        type: "OBJECTID",
        payload
    }
}

export default setCurrentObjectId;


// WEBPACK FOOTER //
// ./src/actions/setCurrentObjectId.js